module.exports = "/static-assets/_next/static/images/Poloaroid-8-9b75679522c7d9c5909921e31dbd4bc2.png";